export default "__VITE_ASSET__Cah0W201__"